import React from "react";
import { Card } from 'react-bootstrap';
import { Container, Row, Col } from 'react-bootstrap';
// import { Container, Row, Col } from 'react-bootstrap';
import './Products.css';

import prodtpctrlbg from '../images/PageImg/ProductTouchCtrl-page-bg.jpg'
import HeaderSlide from '../components/HeaderSlide'
import { TpCtrlBdTxt } from "../assets/ProductTpCtrlData";
import { GoTopBtn } from '../components/GoTopBtn';

function ProductTpCtrlBd() {
  // console.log("get into ProductTpCtrlBd()");
  return (
    <div className='products-page container-fluid'>
      <div className='productheader'
        style={{ backgroundImage: `url(${prodtpctrlbg})`, height: "50vh" }} >
        {/* style={{ backgroundImage: `url(${prodtpctrlbg})`, height: "auto" }} > */}
        <HeaderSlide text={'Product / Touch Control Board'} />
        <h4 className='text-dark'>&nbsp;images/PageImg/ProductTouchCtrl-page-bg.jpg</h4>
      </div>
      <section id='touchctrl' className='product-block touchctrlbd-block bg-primary-subtle'>
        {/*
        <div className='title-holder text-center'>
          <h1 className='prodtpctrlbd'>Product/Touch Control Board</h1>
          <h3 className='text-center text-danger'>PageImg/touchCtrlBoard.jpg</h3>
        </div>
        */}
        <Container fluid>
          <h2 className='text-center'>HLZ Touch Controller & FPCa</h2>
          <h3 className='text-center'>Some of our Touch Controller</h3>
          <Row style={{ marginTop: '2%' }}> {
            TpCtrlBdTxt.map((ctrler, index) => (
              <Col lg={4} style={{ marginBottom: '2%' }}>
                <Card className='border-2' style={{ width: '24rem', maxheight: '70vh' }}>
                  <Card.Img src={ctrler.image} className='border-1' variant='top' />
                  {/* <Card.Img src={ctrler.image} style={{ height: 'auto' }} variant='top' /> */}
                  <Card.Text className='text-danger text-center fs-6'>{ctrler.alt}</Card.Text>
                  <Card.Body>
                    <Card.Title className='text-center'>{ctrler.title}</Card.Title>
                    <Card.Text className='describe text-center'> {ctrler.describe} </Card.Text>
                    <Card.Text className='detail text-start'> {ctrler.detail} </Card.Text>
                    {/* <Card.Text className='describe text-center' style={{ height: '5vh' }}> {ctrler.describe} </Card.Text> */}
                    {/* <Card.Text className='detail text-center' style={{ height: '5vh' }}> {ctrler.detail} </Card.Text> */}
                  </Card.Body>
                </Card>
              </ Col>
            ))}
          </Row>
        </Container>

        {/*
        <Container fluid>
          <h2 className='text-center'>HLZ Touch Controller</h2>
          <h3 className='text-center'>Some of our Touch Controller & FPCa</h3>
          <Row> {
            TpCtrlBdTxt.map(ctrlr => {
              return (
                <Col sm={4} key={ctrlr.id}>
                  <Row className='image'>
                    {/* <Row className='image d-flex justify-content-center'>
                    <Image src={ctrlr.image} style={{ height: 'auto' }} alt={ctrlr.alt} />
                    {/* <Image src={ctrlr.image} alt={ctrlr.alt} />
                    {/* <Image src={ctrlr.image} style={{ height: '40vh' }} alt={ctrlr.alt} />
                    <h4 className='text-danger text-center'>{ctrlr.alt}</h4>
                    <div className='overlay'> <div className='socials'> </div> </div>
                    <div className='text-center'>
                      <p className='fs-3'>{ctrlr.title}</p>
                      <p className='fs-5'>{ctrlr.describe}</p>
                      <p className='fs-5 text-start'>{ctrlr.text}</p>
                    </div>
                  </Row>
                </Col>
              );
            })
          } </Row>
        </ Container>
        */}

        <div> < GoTopBtn /> </div>
      </section>
    </div>
  )
}

export default ProductTpCtrlBd;